import React, { Fragment } from "react";
import useForm from "../../../../hooks/useForm";
import Input from "../../../form/Input";
import Button from "../../../form/Button";
import { otpVerification, sendOtp } from "../../../../services/authService";
import { toast } from "react-toastify";
import OtpInput from "../../../form/OtpInput";
import { useLocation, useNavigate } from "react-router-dom";
import ResendOtpButton from "../../../form/ResendOtpButton";

const validation = {
  email: [
    {
      type: "email",
      required: true,
      message: "Enter valid Email",
    },
  ],
  otp: { required: true, message: "Please Enter Valid Otp" },
};

const OtpVerificationForm = () => {
  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    resetField,
    formValidate,
  } = useForm({ validationRules: validation });

  const navigate = useNavigate();
  const location = useLocation();

  const autoCountDown = location?.state?.autoCountDown;

  // const {
  //   mutate,
  //   error: signUpError,
  //   isPending: signUpPending,
  //   data: signUpData,
  // } = useMutation({
  //   mutationFn: async (val) => {
  //     return await otpVerification({
  //       ...val,
  //     });
  //   },
  //   onSuccess: async (res) => {
  //     if (res?.status === 200 || res?.status === 201) {
  //       navigate("/authentication");
  //     } else {
  //       toast.warning(res?.message || res?.error);
  //     }
  //   },
  // });

  // const {
  //   mutate: handleOtpResend,
  //   isPending: resendOtpPending,
  //   data: otpData,
  // } = useMutation({
  //   mutationFn: async (val) => {
  //     return await sendOtp({
  //       email: val?.email,
  //     });
  //   },
  //   onSuccess: async (res) => {
  //     if (res.status >= 200 && res.status < 300) {
  //       toast.success(res?.message);
  //     } else {
  //       toast.warning(res?.message || res?.error);
  //     }
  //   },
  // });

  return (
    <form
      className="space-y-4"
      onSubmit={(event) => handleSubmit(event, () => {})}
    >
      <Fragment>
        <div className="relative">
          <Input
            label={"Email Address"}
            inputPlaceholder={"Enter Email Address"}
            labelClasses={"!text-white !text-base"}
            inputClasses={
              "!h-12 !rounded-lg !border-white !bg-transparent !text-white placeholder:!text-white focus:!border-primary"
            }
            inputType={"email"}
            inputName="email"
            value={values?.email}
            onChange={handleChange}
            {...formValidate(errors, "email")}
          />
        </div>
        <ResendOtpButton
          onResend={() => {
            const isEmailValid = !errors?.email;
            if (isEmailValid && values?.email) {
              // handleOtpResend({ email: values.email });
            } else {
              handleChange({ target: { name: "email", value: values.email } });
            }
          }}
          // isPanding={resendOtpPending}
          // otpData={otpData}
          autoCountDown={autoCountDown}
        />
        <div className="relative">
          <OtpInput
            label={"Enter the code to confirm"}
            handleOtpChange={(val) =>
              handleChange({
                target: { value: val, name: "otp" },
              })
            }
            inputName="otp"
            labelChildClass={
              "!h-12 !rounded-lg !border-white !bg-transparent !text-white placeholder:!text-white focus:!border-primary"
            }
            {...formValidate(errors, "otp")}
          />
        </div>
      </Fragment>
      <div className="relative">
        <Button
          buttonLabel={"Confirm Account"}
          buttonType="submit"
          buttonLabelClasses={"!text-lg !font-semibold"}
          buttonClasses={"!w-full !h-12 !rounded-lg"}
          // loading={signUpPending}
          // isDisable={signUpPending}
          buttonIconPosition="left"
        />
      </div>
    </form>
  );
};

export default OtpVerificationForm;
